import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/mergeMap';
import { StatusKey } from '@atlassian/jira-providers-issue/src/model/issue-system-fields.tsx';
import { REFRESH_SOURCE_STATUS_REMAPPED } from '../../model/constants.tsx';
import { refreshDataRequest } from '../../state/actions/app/index.tsx';
import {
	CARD_STATUS_CHECK,
	type CardStatusCheckAction,
} from '../../state/actions/status/index.tsx';
import { getAllCardIdsIncludingIssueParents } from '../../state/selectors/cards/index.tsx';
import { isStatusMappedToBoardOld } from '../../state/selectors/statuses/index.tsx';
import type { MiddlewareAPI, ActionsObservable } from '../../state/types.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$.ofType(CARD_STATUS_CHECK).mergeMap((action: CardStatusCheckAction) => {
		const { payload } = action;

		if ('fieldId' in payload && payload.fieldId !== StatusKey) {
			return Observable.empty<never>();
		}

		const state = store.getState();
		const hasIssueOnBacklog = getAllCardIdsIncludingIssueParents(state).includes(
			Number(payload.issueId),
		);
		// since ChangeEvent can be of different type and not all have fieldValue
		// @ts-expect-error - TS2339 - Property 'fieldValue' does not exist on type '{ fieldId: string; fieldValue: any; } | { fieldId: string; } | { fieldId: string; fieldValue: any; } | { typeName: string; } | { newParentIssueId: string | null; oldParentIssueId: string | null; } | ChangedIssueLink | { ...; } | { ...; } | { ...; }'.
		const isStatusIdMappedToBoard = payload.meta.fieldValue
			? // @ts-expect-error - TS2339 - Property 'fieldValue' does not exist on type '{ fieldId: string; fieldValue: any; } | { fieldId: string; } | { fieldId: string; fieldValue: any; } | { typeName: string; } | { newParentIssueId: string | null; oldParentIssueId: string | null; } | ChangedIssueLink | { ...; } | { ...; } | { ...; }'.
				isStatusMappedToBoardOld(payload.meta.fieldValue.id)(state)
			: false;

		// if an unmapped issue(including parent) does not exist on backlog & its remapped with status change,
		// need to refresh the data, so that issue will reappear on backlog
		return !hasIssueOnBacklog && isStatusIdMappedToBoard
			? Observable.of(refreshDataRequest(REFRESH_SOURCE_STATUS_REMAPPED))
			: Observable.empty<never>();
	});
